import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateLogoShowcaseTabData,logoShowcaseTabData }) => {
     const [sidebarLayoutType, setSidebarLayoutType] = useState(logoShowcaseTabData.sidebar_layout_type);
     const [logoSize, setLogoSize] = useState(logoShowcaseTabData.logo_size);
     const [spacingBetweenLogo, setSpacingBetweenLogo] = useState(logoShowcaseTabData.spacing_between_logo);

    // Handle Sidebar Layout Type change
    const handleSidebarLayoutTypeChange = (event) => {
        setSidebarLayoutType(event.target.value);
        updateLogoShowcaseTabData("sidebar_layout_type", event.target.value);
    };

    // Handlers Logo Size Change
    const handleLogoSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 20;
        const MAX_SIZE = 300;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setLogoSize(valueWithPx); 
        updateLogoShowcaseTabData("logo_size", valueWithPx);
    };

    // Handlers Spacing Between Logo Change
    const handleSpacingBetweenLogoChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 0;
        const MAX_SIZE = 200;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setSpacingBetweenLogo(valueWithPx); 
        updateLogoShowcaseTabData("spacing_between_logo", valueWithPx);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <p>Layout</p>
                    <div className="left-cnater-right-button mb-0">
                        <label className="card-radio-btn">
                            <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="Carousel" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "Carousel"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g clip-path="url(#configurator-choice-logo-showcase-layout-slider_svg__a)"><path fill-rule="evenodd" d="M22 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h12Zm4.301 3.307a1.016 1.016 0 0 1 1.456 0l2.64 2.71a2.126 2.126 0 0 1 0 2.967l-2.64 2.709c-.402.41-1.053.41-1.456 0a1.063 1.063 0 0 1 0-1.484l1.912-1.967a1.063 1.063 0 0 0 0-1.484l-1.912-1.967a1.063 1.063 0 0 1 0-1.484Zm-54.603 0c.403.41.403 1.074 0 1.484l-1.911 1.967a1.063 1.063 0 0 0 0 1.484l1.911 1.967c.403.41.403 1.074 0 1.484-.402.41-1.053.41-1.455 0l-2.64-2.71a2.127 2.127 0 0 1 0-2.967l2.64-2.709a1.016 1.016 0 0 1 1.455 0Z" clip-rule="evenodd"></path></g><defs><clipPath id="configurator-choice-logo-showcase-layout-slider_svg__a"><path d="M0 0h64v64H0z"></path></clipPath></defs></svg>
                                </div>
                                <div className="content_sub">Carousel</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="Ticker" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "Ticker"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g clip-path="url(#configurator-choice-logo-showcase-layout-carousel_svg__a)"><path d="M43.757 15.807a1.016 1.016 0 0 0-1.456 0 1.063 1.063 0 0 0 0 1.484l.669.709H29a1 1 0 1 0 0 2h13.97l-.669.71a1.063 1.063 0 0 0 0 1.483c.402.41 1.054.41 1.456 0l1.64-1.71a2.127 2.127 0 0 0 0-2.967l-1.64-1.709ZM5 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H0v-2c0-1.072.287-2.144.554-3.139C.784 34 1 33.197 1 32.5c0-.696-.215-1.5-.446-2.362C.287 29.144 0 28.072 0 27v-2h5Zm52 14a1 1 0 0 0 1 1h5v-2c0-1.072.287-2.144.554-3.139.23-.861.446-1.665.446-2.361 0-.696-.215-1.5-.446-2.362C63.287 29.143 63 28.072 63 27v-2h-5a1 1 0 0 0-1 1v13ZM22 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm18 1a1 1 0 0 0-1-1H26a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V26Zm15-1a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h12Zm-32-6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-4-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"></path></g><defs><clipPath id="configurator-choice-logo-showcase-layout-carousel_svg__a"><path d="M0 0h64v64H0z"></path></clipPath></defs></svg>
                                </div>
                                <div className="content_sub">Ticker</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="sidebar_layout_type" className="card-input-element d-none" value="Grid" onChange={handleSidebarLayoutTypeChange} checked={sidebarLayoutType === "Grid"} />
                            <div className="card card-body">
                                <div className="content_sub">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M22 42a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h12ZM22 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h12ZM22 8a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12Z" clip-rule="evenodd"></path></svg>
                                </div>
                                <div className="content_sub">Grid</div>
                            </div>
                        </label>
                    </div>
                </div>
                <div className="side-baar-box-header mb-3">
                    <div className="box-header-row">
                        <span>Logo Size</span>
                        <em>{parseInt(logoSize)}px</em>
                        <div className="slider-container">
                            <input
                                type="range"
                                min="20"
                                max="300"
                                value={parseInt(logoSize)}
                                onChange={handleLogoSizeChange}
                            />
                        </div>
                    </div>
                    <div className="box-header-row">
                        <span>Spacing Between Logos</span>
                        <em>{parseInt(spacingBetweenLogo)}px</em>
                        <div className="slider-container">
                            <input
                                type="range"
                                min="0"
                                max="200"
                                value={parseInt(spacingBetweenLogo)}
                                onChange={handleSpacingBetweenLogoChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;